import type { SlateBlock, BulletedListBlock, NumberedListBlock } from '@atlas/renderer';

export default function isListBlock(element: SlateBlock): element is ListBlock {
    return (LIST_BLOCKS_TYPES as Array<SlateBlock['type']>).includes(element.type);
}

// #region Helpers

export const LIST_BLOCKS_TYPES: Array<ListBlock['type']> = ['numbered-list', 'bulleted-list'];

// #endregion

// #region Types

export type ListBlock = NumberedListBlock | BulletedListBlock;

// #endregion

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('isListBlock', async () => {
        it.todo('🤷🏼');
    });
}

// #endregion
